/**
 * SessionTimeout — FRD §36
 * Auto-logs out after 20 minutes of inactivity on any dashboard page.
 */
import { useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const TIMEOUT_MS = 20 * 60 * 1000; // 20 minutes
const EVENTS = ["mousemove", "mousedown", "keydown", "touchstart", "scroll", "click"];

export default function SessionTimeout() {
  const timerRef = useRef(null);
  const navigate  = useNavigate();

  const doLogout = useCallback(() => {
    sessionStorage.clear();
    navigate("/login");
  }, [navigate]);

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(doLogout, TIMEOUT_MS);
  }, [doLogout]);

  useEffect(() => {
    // Only activate when a user is logged in
    const isLoggedIn = !!sessionStorage.getItem("role");
    if (!isLoggedIn) return;

    EVENTS.forEach(e => window.addEventListener(e, resetTimer, { passive: true }));
    resetTimer(); // Start the initial timer

    return () => {
      EVENTS.forEach(e => window.removeEventListener(e, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [resetTimer]);

  return null; // Renders nothing — purely behavioural
}
